import { MdOutlineFilterList, MdFilterListOff } from "react-icons/md";

function ToggleFilterButton({ openColumnFilter, handleColumnFilterToggle }) {
  return (
    <button
      className="tw-flex tw-justify-center tw-items-center tw-bg-transparent tw-outline-none tw-border-0 tw-rounded-full focus:tw-outline-none"
      type="button"
      data-toggle="tooltip"
      data-placement="top"
      title="Filter"
      onClick={handleColumnFilterToggle}
    >
      {openColumnFilter ? (
        <MdFilterListOff className="tw-w-6 tw-h-6 tw-text-gray-500" />
      ) : (
        <MdOutlineFilterList className="tw-w-6 tw-h-6 tw-text-gray-900" />
      )}
    </button>
  );
}

export default ToggleFilterButton;
